"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var PROP_TYPES = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  paragraph: _propTypes["default"].string,
  disclaimerLabel: _propTypes["default"].string,
  useAccordion: _propTypes["default"].bool,
  hideDisclaimer: _propTypes["default"].bool,
  disclaimerList: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    disclaimerNumber: _propTypes["default"].string,
    disclaimerContent: _propTypes["default"].string,
    associated: _propTypes["default"].string
  }))
});
var _default = PROP_TYPES;
exports["default"] = _default;